import React from "react";
import { useParams, useLocation } from "react-router";
import { SmallButton } from "../DesignSystem/SmallButton";
import {
  Cog6ToothIcon,
  UserGroupIcon,
  ClipboardDocumentCheckIcon,
  ListBulletIcon,
  ChartBarIcon,
} from "@heroicons/react/24/outline";
import { TestIds } from "../testIds";

export function AdminToolbar() {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();

  const links = [
    { to: `/compo/${id}/admin`, label: "Admin Main", icon: Cog6ToothIcon },
    {
      to: `/compo/${id}/admin/badvoters`,
      label: "Slacker Voters",
      icon: UserGroupIcon,
      testId: TestIds.AdminBadVotersLink,
    },
    {
      to: `/compo/${id}/admin/voteaudit`,
      label: "Audit Votes",
      icon: ClipboardDocumentCheckIcon,
    },
    {
      to: `/compo/${id}/admin/votesrequired`,
      label: "Required Votes",
      icon: ListBulletIcon,
      testId: TestIds.AdminVotesRequiredLink,
    },
    {
      to: `/compo/${id}/admin/results`,
      label: "Results",
      icon: ChartBarIcon,
    },
  ];

  return (
    <div className="fixed top-[4.5rem] z-40 w-full border-b border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-800">
      <div className="mx-auto flex max-w-4xl items-center gap-1 px-4 py-2">
        {links.map((link) => {
          const isActive = location.pathname === link.to;
          const Icon = link.icon;
          return (
            <SmallButton
              key={link.to}
              to={link.to}
              icon={<Icon className="h-4 w-4" />}
              variant="blue"
              active={isActive}
              testId={link.testId}
            >
              {link.label}
            </SmallButton>
          );
        })}
      </div>
    </div>
  );
}
